import { FunctionComponent } from "react";
import "./Button.scss";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string;
  content?: string;
}

const Button: FunctionComponent<IProps> = (props) => {
  const getClasses = () => {
    const classes = [];

    classes.push("button");
    classes.push(props.className);

    if (props.icon && !props.content) {
      classes.push("button--icon-only");
    }

    return classes.join(" ");
  };

  return (
    <button {...props} className={getClasses()}>
      {props.icon && <span className={"icon-" + props.icon}></span>}
      {props.content && <span>{props.content}</span>}
    </button>
  );
};

export default Button;
